// ไฟล์: frontend/src/pages/admin/Profile.js
import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import Footer from "../../components/Footer";
import api from "../../services/api";
import authService from "../../services/auth";
import Swal from "sweetalert2";

function AdminProfile() {
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState({});
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    profile_pic: null,
  });
  const [passwordData, setPasswordData] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",
  });
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {
      setIsLoading(true);
      const response = await api.user.getCurrentUser();
      const userData = response.data.data;

      setUser(userData);
      setFormData({
        first_name: userData.first_name || "",
        last_name: userData.last_name || "",
        email: userData.email || "",
        profile_pic: null,
      });

      setPreviewImage(
        userData.profile_pic
          ? `https://cms2568.backend.kruwirat.com/uploads/${userData.profile_pic}`
          : null
      );
    } catch (error) {
      console.error("Error fetching user data:", error);
      Swal.fire({
        icon: "error",
        title: "เกิดข้อผิดพลาด",
        text: "ไม่สามารถโหลดข้อมูลผู้ใช้ได้",
        confirmButtonColor: "#ff6b01",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData({
      ...passwordData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({
        ...formData,
        profile_pic: file,
      });

      // สร้าง URL สำหรับแสดงตัวอย่างรูปภาพ
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true);

      // สร้าง FormData สำหรับส่งข้อมูลพร้อมรูปภาพ
      const data = new FormData();
      data.append("first_name", formData.first_name);
      data.append("last_name", formData.last_name);
      data.append("email", formData.email);

      if (formData.profile_pic) {
        data.append("profile_pic", formData.profile_pic);
      }

      // อัปเดตข้อมูลผู้ใช้
      const response = await api.user.updateUser(user.id, data);

      // อัปเดตข้อมูลผู้ใช้ใน localStorage
      authService.updateUserData({
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        profile_pic: response.data.profile_pic || user.profile_pic,
      });

      Swal.fire({
        icon: "success",
        title: "สำเร็จ",
        text: "อัปเดตข้อมูลส่วนตัวเรียบร้อยแล้ว",
        confirmButtonColor: "#ff6b01",
      });

      // โหลดข้อมูลใหม่
      fetchUserData();
    } catch (error) {
      console.error("Error updating profile:", error);
      Swal.fire({
        icon: "error",
        title: "เกิดข้อผิดพลาด",
        text: "ไม่สามารถอัปเดตข้อมูลส่วนตัวได้",
        confirmButtonColor: "#ff6b01",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();

    // ตรวจสอบรหัสผ่านใหม่
    if (passwordData.new_password !== passwordData.confirm_password) {
      Swal.fire({
        icon: "error",
        title: "รหัสผ่านไม่ตรงกัน",
        text: "รหัสผ่านใหม่และยืนยันรหัสผ่านไม่ตรงกัน",
        confirmButtonColor: "#ff6b01",
      });
      return;
    }

    try {
      setIsLoading(true);

      // ส่งคำขอเปลี่ยนรหัสผ่าน
      await api.user.changePassword(user.id, {
        current_password: passwordData.current_password,
        new_password: passwordData.new_password,
      });

      Swal.fire({
        icon: "success",
        title: "สำเร็จ",
        text: "เปลี่ยนรหัสผ่านเรียบร้อยแล้ว",
        confirmButtonColor: "#ff6b01",
      });

      // ล้างฟอร์ม
      setPasswordData({
        current_password: "",
        new_password: "",
        confirm_password: "",
      });
    } catch (error) {
      console.error("Error changing password:", error);
      let errorMsg = "ไม่สามารถเปลี่ยนรหัสผ่านได้";

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMsg = error.response.data.message;
      }

      Swal.fire({
        icon: "error",
        title: "เกิดข้อผิดพลาด",
        text: errorMsg,
        confirmButtonColor: "#ff6b01",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="wrapper">
      <Header />
      <Sidebar />

      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">ข้อมูลส่วนตัว</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="/admin/dashboard">หน้าหลัก</a>
                  </li>
                  <li className="breadcrumb-item active">ข้อมูลส่วนตัว</li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            {isLoading ? (
              <div className="loading-spinner">
                <i className="fas fa-spinner fa-spin"></i>
              </div>
            ) : (
              <div className="row">
                {/* ข้อมูลผู้ใช้ */}
                <div className="col-md-4">
                  <div className="card card-orange card-outline">
                    <div className="card-body box-profile">
                      <div className="text-center">
                        <img
                          className="profile-user-img img-fluid img-circle"
                          src={
                            previewImage || "https://via.placeholder.com/150"
                          }
                          alt="User profile"
                          style={{
                            width: "150px",
                            height: "150px",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                      <h3 className="profile-username text-center">
                        {user.first_name} {user.last_name}
                      </h3>
                      <p className="text-muted text-center">ผู้ดูแลระบบ</p>
                      <ul className="list-group list-group-unbordered mb-3">
                        <li className="list-group-item">
                          <b>ชื่อผู้ใช้</b>{" "}
                          <span className="float-right">{user.username}</span>
                        </li>
                        <li className="list-group-item">
                          <b>อีเมล</b>{" "}
                          <span className="float-right">
                            {user.email || "-"}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* แก้ไขข้อมูลส่วนตัว */}
                <div className="col-md-8">
                  <div className="card card-orange card-outline">
                    <div className="card-header">
                      <h3 className="card-title">แก้ไขข้อมูลส่วนตัว</h3>
                    </div>
                    <div className="card-body">
                      <form onSubmit={handleProfileSubmit}>
                        <div className="form-group">
                          <label>ชื่อ</label>
                          <input
                            type="text"
                            className="form-control"
                            name="first_name"
                            value={formData.first_name}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                        <div className="form-group">
                          <label>นามสกุล</label>
                          <input
                            type="text"
                            className="form-control"
                            name="last_name"
                            value={formData.last_name}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                        <div className="form-group">
                          <label>อีเมล</label>
                          <input
                            type="email"
                            className="form-control"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                          />
                        </div>
                        <div className="form-group">
                          <label>รูปโปรไฟล์</label>
                          <div className="custom-file">
                            <input
                              type="file"
                              className="custom-file-input"
                              id="profile_pic"
                              name="profile_pic"
                              onChange={handleFileChange}
                              accept="image/*"
                            />
                            <label
                              className="custom-file-label"
                              htmlFor="profile_pic"
                            >
                              {formData.profile_pic
                                ? formData.profile_pic.name
                                : "เลือกรูปภาพ"}
                            </label>
                          </div>
                        </div>
                        <button
                          type="submit"
                          className="btn btn-orange"
                          disabled={isLoading}
                        >
                          {isLoading ? (
                            <>
                              <i className="fas fa-spinner fa-spin"></i>{" "}
                              กำลังบันทึก...
                            </>
                          ) : (
                            <>บันทึกข้อมูล</>
                          )}
                        </button>
                      </form>
                    </div>
                  </div>

                  {/* เปลี่ยนรหัสผ่าน */}
                  <div className="card card-orange card-outline">
                    <div className="card-header">
                      <h3 className="card-title">เปลี่ยนรหัสผ่าน</h3>
                    </div>
                    <div className="card-body">
                      <form onSubmit={handlePasswordSubmit}>
                        <div className="form-group">
                          <label>รหัสผ่านปัจจุบัน</label>
                          <input
                            type="password"
                            className="form-control"
                            name="current_password"
                            value={passwordData.current_password}
                            onChange={handlePasswordChange}
                            required
                          />
                        </div>
                        <div className="form-group">
                          <label>รหัสผ่านใหม่</label>
                          <input
                            type="password"
                            className="form-control"
                            name="new_password"
                            value={passwordData.new_password}
                            onChange={handlePasswordChange}
                            required
                          />
                        </div>
                        <div className="form-group">
                          <label>ยืนยันรหัสผ่านใหม่</label>
                          <input
                            type="password"
                            className="form-control"
                            name="confirm_password"
                            value={passwordData.confirm_password}
                            onChange={handlePasswordChange}
                            required
                          />
                        </div>
                        <button
                          type="submit"
                          className="btn btn-orange"
                          disabled={isLoading}
                        >
                          {isLoading ? (
                            <>
                              <i className="fas fa-spinner fa-spin"></i>{" "}
                              กำลังบันทึก...
                            </>
                          ) : (
                            <>เปลี่ยนรหัสผ่าน</>
                          )}
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}

export default AdminProfile;
